import { BigCommerceEndpointTagTypes, JimboResponse, ShippingMethodZones } from '@models';
import { BaseQueryFn } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export const shippingEndpoints = (
  builder: EndpointBuilder<
    // eslint-disable-next-line @typescript-eslint/ban-types
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    BigCommerceEndpointTagTypes,
    'bigCommerceApi'
  >,
) => {
  return {
    getDeliveryFee: builder.query<ShippingMethodZones, { state: string }>({
      query: (query) => `shipping/${query.state}`,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transformResponse: (response: JimboResponse<ShippingMethodZones>) => response.data!,
    }),
  };
};
